import React from "react";
import {
    SovosBox,
    SovosButton,
    SovosDialog,
    SovosDialogActions,
    SovosDialogContent,
    SovosDialogTitle,
    SovosIconButton,
    SovosTypography,
} from "mosaic-react";
import { Close } from "mosaic-react-icons";
import { DO_NOT_IMPORT } from "../constants";
import { stripCdmPrefix } from "../utils";

const ConfirmDialog = ({ open, onCancel, onConfirm, mappings, mschFields, i18n }) => {
    const mappedEntries = Object.entries(mappings).filter(([, v]) => v && v !== DO_NOT_IMPORT);
    return (
        <SovosDialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <SovosBox sx={{ position: "absolute", top: 8, right: 8 }}>
                <SovosIconButton size="small" tooltipText={i18n`Close`} onClick={onCancel}>
                    <Close fontSize="small" />
                </SovosIconButton>
            </SovosBox>
            <SovosDialogTitle>{i18n`Confirm your column mapping?`}</SovosDialogTitle>
            <SovosDialogContent>
                <SovosTypography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    {i18n`Please review the column mapping below before proceeding to data validation.`}
                </SovosTypography>
                <SovosBox
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        overflow: "hidden",
                        mb: 1,
                    }}
                >
                    {mappedEntries.map(([col, fieldId], idx) => {
                        const field = mschFields.find((f) => f.id === fieldId);
                        const sourceLabel = stripCdmPrefix(col);
                        const targetLabel = field?.name || fieldId;
                        return (
                            <SovosBox
                                key={col}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 1.5,
                                    py: 0.75,
                                    bgcolor: idx % 2 === 0 ? "action.hover" : "transparent",
                                }}
                            >
                                <SovosTypography variant="caption" fontWeight={600} sx={{ flex: 1 }} noWrap>
                                    {sourceLabel}
                                </SovosTypography>
                                <SovosTypography variant="caption" color="text.secondary" sx={{ mx: 0.5 }}>→</SovosTypography>
                                <SovosTypography variant="caption" sx={{ flex: 1 }} noWrap>
                                    {targetLabel}
                                </SovosTypography>
                            </SovosBox>
                        );
                    })}
                </SovosBox>
            </SovosDialogContent>
            <SovosDialogActions>
                <SovosButton variant="text" onClick={onCancel}>
                    {i18n`Cancel`}
                </SovosButton>
                <SovosButton variant="contained" onClick={onConfirm}>
                    {i18n`Confirm column mapping`}
                </SovosButton>
            </SovosDialogActions>
        </SovosDialog>
    );
};

export default ConfirmDialog;
